
import * as joi from '@hapi/joi';

export class ValidationUtil {

  validCustomMeta = joi.object().pattern(
    joi.string(),
    joi.alternatives(
      joi.number(),
      joi.string(),
      joi.bool(),
      joi.array().items(joi.number()),
      joi.array().items(joi.string()),
  )).min(1).error(() => new Error(`allowed custom metadata values are: number, string, booleans, number[], string[]. Specify at least one key`));
}